import { useContext } from 'react'
import { DocumentPreviewContext } from './documentPreviewContextValue.js'

export function useDocumentPreview() {
  const ctx = useContext(DocumentPreviewContext)
  if (!ctx) {
    throw new Error('useDocumentPreview must be used within DocumentPreviewProvider')
  }
  return ctx
}

export function useDocumentPreviewOptional() {
  return useContext(DocumentPreviewContext)
}
